/* eslint-disable compat/compat */
class LookBookCollection extends window.BAO.CustomElement() {
  connectedCallback () {
    // If data is already saved

    if (sessionStorage.lookbooks) {
      window.theme.fourSixty.data = JSON.parse(sessionStorage.lookbooks)
      this.init()
    } else {
      // If the data is not saved we will have to wait for the requests from FourSixty
      document.addEventListener('lookbookDataIsReady', e => {
        this.init()
      })
    }
  }

  init () {
    this.listeners.add(
      this.els.loadMoreTrigger.element,
      'click',
      this.onLoadMoreTrigger.bind(this),
    )
    window.theme.fourSixty.data = this.paginateResults(
      window.theme.fourSixty.data,
      Number(window.theme.fourSixty.pagination),
    )

    // Hide load more button if only one page of results
    if (window.theme.fourSixty.data.length === 1) {
      this.hideLoadMoreButton()
    }

    if (this.pageNumber() === 1) {
      this.els.item.elements.forEach((item, index) => {
        const firstPage = window.theme.fourSixty.data[0]

        if (firstPage[index] === undefined) {
          // If number of skelton cards is greater than the amount of books the skelton card is removed from the DOM
          item.remove()
        } else {
          // Skelton is replaced with the loaded state of the lookbook
          this.els.list.element.innerHTML = ''
          window.theme.fourSixty.data[0].forEach(book =>
            this.els.list.element.insertAdjacentHTML(
              'beforeend',
              this.returnLookBookTemplate(book),
            ),
          )
        }
      })
      setTimeout(() => {
        this.els.list.element.style.opacity = 1
      }, 1000)
      return
    }

    if (this.pageNumber() !== 1) {
      // render all pages up until current page
      const pages = window.theme.fourSixty.data.filter((item, index) => {
        return index >= 0 && index < this.pageNumber() + 0
      })

      pages.forEach(books => {
        books.forEach(book =>
          this.els.list.element.insertAdjacentHTML(
            'beforeend',
            this.returnLookBookTemplate(book),
          ),
        )
      })
      this.els.item.elements.forEach(el => el.parentElement.remove())
    }
    setTimeout(() => {
      this.els.list.element.style.opacity = 1
    }, 1000)
  }

  hideLoadMoreButton () {
    this.els.loadMoreTrigger.element.style.display = 'none'
  }

  paginateResults (results, pageSize) {
    const paginatedResults = []
    for (let i = 0; i < results.length; i += pageSize) {
      const chunk = results.slice(i, i + pageSize)
      paginatedResults.push(chunk)
    }
    return paginatedResults
  }

  onLoadMoreTrigger () {
    // Get current page
    const currentPage = this.pageNumber()

    if (currentPage === 1) {
      // Load second page of results
      this.loadNextPageOfResults(2)
    } else {
      const nextPage = Number(this.pageNumber()) + 1

      this.loadNextPageOfResults(nextPage)
    }
  }

  pageNumber () {
    return new URL(window.location).searchParams.get('page') === null
      ? 1
      : Number(new URL(window.location).searchParams.get('page'))
  }

  loadNextPageOfResults (nextPage) {
    if (window.theme.fourSixty.data[nextPage - 1] === undefined) return

    const myUrlWithParams = new URL(window.location)

    window.theme.fourSixty.data[nextPage - 1].forEach(book => {
      this.els.list.element.insertAdjacentHTML(
        'beforeend',
        this.returnLookBookTemplate(book),
      )
    })

    myUrlWithParams.searchParams.set('page', `${nextPage}`)

    window.history.replaceState(
      myUrlWithParams.origin,
      '',
      myUrlWithParams.href,
    )
    if (window.theme.fourSixty.data[nextPage] === undefined) {
      this.hideLoadMoreButton()
    }
  }

  returnLookBookTemplate (post) {
    const strings = window.theme.strings.lookBook
    const media = post.embed_url
      ? `<video class="lok-Card_Image" style="width: 100%; max-width: 100%;" src="${post.embed_url}" poster="${post.main_image_url}" muted autoplay loop playsinline></video>`
      : `<img src="${post.main_image_url}" alt="${post.title}" class="lok-Card_Image">`

    let html = `
      <li class="sec-Lookbook_ListItem" ${
        post.embed_url ? `data-embed-url="${post.embed_url}"` : ''
      }>
        <looks-card class="lok-Card">
          <header class="lok-Card_Header">
            <button class="lok-Card_OverlayTrigger" type="button" aria-label="${
              strings.lookOverlayTrigger
            }" data-looks-card-el="overlayTrigger"></button>
            ${media}
            <article class="lok-Card_Overlay lok-Card_Overlay-dark" data-looks-card-el="overlay" aria-hidden="true">
              <ul>
    `
    post.links.forEach(link => {
      if (!link.product) return
      const url = new URL(link.link_url)

      html += `
        <section-async class="lok-Card_OverlayProductAsync"
          section-id="foursixty-product-card-overlay"
          url="${url.pathname}"
          aria-busy="true"
        >
        </section-async>      `
    })

    html += `
              </ul>
            </article>
          </header>
          <footer class="lok-Card_Footer">
            <a href="${post.resource_url}" target="_blank" class="fz-14_100" aria-describedby="a11y-new-window-message">${post.title}</a>
            <button class="lok-CardStateIndication btn-Arrow" type="button" aria-label="${strings.lookOverlayTrigger}" data-looks-card-el="overlayTrigger">
              <span class="btn-Arrow_Icon"></span>
              <span class="btn-Arrow_Copy lok-Card_StateCopy fz-14_100" data-looks-card-el="stateCopy" data-visible-copy="${strings.hideProducts}" data-hidden-copy="${strings.viewProducts}">${strings.viewProducts}</span>
            </button>
          </footer>
        </looks-card>
      </li>
    `
    return html
  }

  localizedPath (url) {
    const root = (window.Shopify?.routes?.root || '/').replace(/\/+$/, '')
    if (root === '' || url.pathname.startsWith(root)) return url.pathname
    return `${root}${url.pathname}`
  }
}

if (!customElements.get('look-book-collection')) {
  customElements.define('look-book-collection', LookBookCollection)
}
